import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import { LocationContext } from "../../../../../../CustomHelper/Helper";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../../CustomHelper/ContdownTimerRender";

const AuctionActivity = ({ event, event_type }) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { countryDateTime } = useContext(LocationContext);

  const bidEnd = new Date(countryDateTime(event?.bid_to, '')).getTime();
  const result_date = new Date(countryDateTime(event?.result_date, '')).getTime();


  return (
    <>
      {bidEnd >= new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEn ">
            <img
              src={imageCdnUrl + event?.product_image}
              alt="Img1"
              className="ImgAc"
              height="180px"
            />

            <div className="joinNowBgLive title_text_ellipsis">
              {event?.title}
            </div>
            <Link to={`auction/${event?.id}`}>
              <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLive">
                Bid Now
              </h6>
            </Link>

            <Countdown
                  date={bidEnd}
                  renderer={ContdownTimerRender} />
          </div>
        </div>
      ) : bidEnd < new Date().getTime() &&
        result_date > new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEnLive ">
            <img
              src={imageCdnUrl + event?.product_image}
              alt="Img1"
              className="ImgAc"
              height="180px"
            />

            <div className="joinNowBg">Running</div>

            <div className="joinNowBgLive title_text_ellipsis">
              {event?.title}
            </div>

            {event_type === "auction" ? (
              <Link className="Link" to={`auction/${event?.id}`}>
                <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                  Accuired Application
                </h6>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : result_date < new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEnLive ">
            <img
              src={imageCdnUrl + event?.product_image}
              alt="Img1"
              className="ImgAc"
              height="180px"
            />

            <div className="joinNowBg">Published</div>

            <div className="joinNowBgLive title_text_ellipsis">
              {event?.title}
            </div>

            {event_type === "auction" ? (
              <Link className="Link" to={`auction-winner/${event?.id}`}>
                <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                  Show Result
                </h6>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEn">
            <img
              src={imageCdnUrl + event?.product_image}
              alt="Img1"
              className="ImgAc"
              height="180px"
            />

            <div className="joinNowBgLive title_text_ellipsis">
              {event?.title}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuctionActivity;
